module.exports = __webpack_public_path__ + "img/userLogo5.44553353.jpg";